import { gql } from '@apollo/client';
/**
 * @fragment SaleItemConnectorRefFragment
 * @since 1.0.0
 */
export const SaleItemConnectorRefFragment = gql `
  fragment SaleItemConnectorRefFragment on SaleItemConnectorRef {
    assetId
    connectionId
    saleItemId
    saleItemUuid
    ref
    serviceId
    saleItem {
      id
      title
    }
  }
`;
